export const csvExample = `brand,model,year,price,rating
ford,mustang,1970,200,9
ford,camaro,1990,200,6
dacia,duster,2012,50,6
dacia,solenza,1985,10,1
tesla,roadster,2020,200,10
dacia,logan,2000,50,4
bugatti,veyron,2020,500,10`;

export const jsonExample = [
    { brand: "ford", model: "mustang", year: 1970, price: 200, rating: 9 },
    { brand: "ford", model: "camaro", year: 1990, price: 200, rating: 6 },
    { brand: "dacia", model: "duster", year: 2012, price: 50, rating: 6 },
    { brand: "dacia", model: "solenza", year: 1985, price: 10, rating: 1 },
    { brand: "tesla", model: "roadster", year: 2020, price: 200, rating: 10 },
    { brand: "dacia", model: "logan", year: 2000, price: 50, rating: 4 },
    { brand: "bugatti", model: "veyron", year: 2020, price: 500, rating: 10 }
];
